import type { ReactNode } from "react";
import { useSession } from "../../app/session.js";
import { BrandMark, focusRing, LogoutIcon, Notice } from "../../ui/index.js";
import { useLogout } from "../cabinet/index.js";

/**
 * Верхняя строка страниц админки без оболочки кабинета (список салонов, карточка салона):
 * кто вошёл и «Выйти». Выход тот же, что в «Ещё» кабинета (`useLogout`); после него `RequireAdmin` уводит на вход.
 * Страница рисует строку и пока данные грузятся, и при ошибке загрузки: выйти можно всегда.
 */
export function AdminTopBar({ left, className = "" }: { left?: ReactNode; className?: string }) {
  const session = useSession();
  const { logout, pending, error } = useLogout();
  return (
    <div className={className}>
      <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-b border-line pb-3 text-sm text-ink-3">
        <div className="flex items-center gap-3">
          <BrandMark className="h-8 w-8" />
          {left}
        </div>
        <div className="flex min-w-0 items-center gap-3">
          <span className="truncate">{session.user?.email}</span>
          <button
            type="button"
            className={`inline-flex shrink-0 items-center gap-1.5 rounded font-medium text-ink-2 hover:text-ink ${focusRing}`}
            onClick={() => void logout()}
            disabled={pending}
          >
            <LogoutIcon className="h-4 w-4" />
            Выйти
          </button>
        </div>
      </div>
      {error && (
        <div className="mt-2">
          <Notice kind="error">Не удалось выйти: {error.message}</Notice>
        </div>
      )}
    </div>
  );
}
